import {useTranslation} from 'react-i18next';
import {Helper} from '@tickchak/react-share/app';
import {TicketAmount} from '../../../../../../assets/icons/TicketAmountIcon';
import ParticipantsIcon from '../../../../../../assets/icons/ParticipantsIcon';
import PurchasersLimitIcon from '../../../../../../assets/icons/PurchasersLimitIcon';
import NumberInput from '../../../../../../component/input/NumberInput';
import * as css from '../PricingStep/PricingStep.css';

function TicketAmountSection() {
    const {t} = useTranslation('subscriptions');

    return (
        <css.sectionWrapper>
            <css.headerTitle $icon={TicketAmount}>
                {t('subscriptionsAmountTitle')}
            </css.headerTitle>
            <css.section>
                <css.inputsRow>
                    <css.localInputWrapper>
                        <NumberInput
                            name="ticketsAmount"
                            text={t('subscriptionsAmount')}
                            icon={<ParticipantsIcon />}
                            className=""
                            forwardRef={null}
                        />
                        <Helper
                            title={t('subscriptionsAmountHelperTitle')}
                            content={t('subscriptionsAmountHelperContent')}
                            size='small'
                        />
                    </css.localInputWrapper>
                    <css.localInputWrapper>
                        <NumberInput
                            name="ticketsLimit"
                            text={t('purchasersLimit')}
                            icon={<PurchasersLimitIcon />}
                            className=""
                            forwardRef={null}
                        />
                        <Helper
                            title={t('purchasersLimitHelperTitle')}
                            content={t('purchasersLimitHelperContent')}
                            size='small'
                        />
                    </css.localInputWrapper>
                </css.inputsRow>
            </css.section>
        </css.sectionWrapper>
    );
}

export default TicketAmountSection;

